import React from 'react';

import modeloPadraoMassaInicial from '../../../assets/modelos/massaInicial/ModeloPadrãoMassaInicial.csv';
import orientaçõesPreenchimentoMassaInicial from '../../../assets/modelos/massaInicial/OrientaçõesPreenchimentoMassaInicial.pdf';

import { ContainerFooter } from './styles';

const TemplateDownloadText = () => (
  <ContainerFooter>
    Para te auxiliar, temos um
    <a href={modeloPadraoMassaInicial} download="ModeloPadraoMassaInicial.csv">
      {' '}
      modelo padrão{' '}
    </a>
    demonstrando como deve ser a estrutura do arquivo csv e as
    <a
      href={orientaçõesPreenchimentoMassaInicial}
      download="OrientaçõesPreenchimentoMassaInicial.pdf"
    >
      {' '}
      orientações de preenchimento{' '}
    </a>
    do arquivo.
  </ContainerFooter>
);

export default TemplateDownloadText;
